import { FaArrowLeft, FaChartPie, FaGauge, FaHandHoldingDollar, FaUsers, FaUsersGear } from "react-icons/fa6";

export default {
	header: {
		self: {},
		items: [],
	},
	aside: {
		self: {},
		items: [
			{
				title: "Dashboard",
				root: true,
				iconComponent: <FaGauge size={20} />,
				page: "dashboard",
				bullet: "dot",
			},
			{
				title: "Clientes",
				root: true,
				iconComponent: <FaUsers size={20} />,
				page: "clientes",
				bullet: "dot",
			},
			{
				title: "Planos",
				root: true,
				iconComponent: <FaHandHoldingDollar size={20} />,
				page: "planos",
				bullet: "dot",
			},
			{
				title: "Relatórios",
				root: true,
				iconComponent: <FaChartPie size={20} />,
				submenu: [
					{
						title: "Financeiro",
						page: "relatorio/financeiro",
						bullet: "text",
					},
					{
						title: "Clientes",
						page: "relatorio/clientes",
						bullet: "text",
					},
				],
			},
			{
				title: "Acessos",
				root: true,
				iconComponent: <FaUsers size={20} />,
				submenu: [
					{
						title: "Usuários",
						page: "admin-user",
						bullet: "text",
					},
					{
						title: "Grupos de usuário",
						page: "admin-group",
						bullet: "text",
					},
				],
			},
			{
				title: "Sair",
				root: true,
				iconComponent: <FaArrowLeft size={20} />,
				page: "logout",
				bullet: "dot",
				mobileOnly: true
			}
		],
	},
};
